import React, { useState } from "react"

function encode(data) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}

export default function Contact() {
  const [state, setState] = useState({})
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState(false)

  const handleChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const form = e.target
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({
        'form-name': form.getAttribute('name'),
        ...state,
      }),
    })
      .then(() => setSubmitted(true))
      .catch(() => setError(true))
  }

  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="contact__heading">
          <p className="eyebrow">Contact</p>
          <h2>Let's talk about your next project</h2>
          <p>
            If you've got an idea, a website that needs improving, or a challenge you want to solve, I'd love to hear about it.
            Share a few details about what you're working on and how you'd like to collaborate, and I'll get back to you as soon as possible.
          </p>
        </div>
        <div className="contact__form">
          {submitted ? (
            <p className="form-success">
              Thanks for getting in touch — I'll be in touch soon!
            </p>
          ) : (
            <form
              name="contact"
              method="POST"
              data-netlify="true"
              data-netlify-honeypot="bot-field"
              id="contact-form"
              onSubmit={handleSubmit}
            >
              <input type="hidden" name="form-name" value="contact" />
              <p hidden>
                <label>
                  Don't fill this out: <input name="bot-field" onChange={handleChange} />
                </label>
              </p>
              <div className="form-field-wrapper">
                <label htmlFor="frmname">Name*</label>
                <input type="text" name="name" id="frmname" placeholder="Joe Bloggs" required onChange={handleChange} />
              </div>
              <div className="form-field-wrapper">
                <label htmlFor="frmemail">Email*</label>
                <input type="email" name="email" id="frmemail" placeholder="joebloggs@mail.com" required onChange={handleChange} />
              </div>
              <div className="form-field-wrapper">
                <label htmlFor="frmtel">Contact Number</label>
                <input type="tel" name="tel" id="frmtel" placeholder="07123456789" onChange={handleChange} />
              </div>
              <div className="form-field-wrapper">
                <label htmlFor="frmservice">What do you need help with?</label>
                <input type="text" name="service" id="frmservice" placeholder="e.g. WordPress theme development" onChange={handleChange} />
              </div>
              <div className="form-field-wrapper">
                <label htmlFor="frmmessage">Your message*</label>
                <textarea name="message" id="frmmessage" placeholder="Tell me a bit about the project" required onChange={handleChange}></textarea>
              </div>
              {error && <p>Something went wrong sending that — mind trying again?</p>}
              <button type="submit" className="btn filled lg">Send message</button>
            </form>
          )}
        </div>
      </div>
    </section>
  )
}